/**
 * Pure decision logic for the root route's app-loading gate.
 * Kept free of React so it can be unit-tested in the node Vitest env.
 */

export type RootRouteState = "loading" | "error" | "verify_email" | "ready";

export function resolveRootRouteState(args: {
  /** Firebase auth state has not resolved yet (first onAuthStateChanged pending) */
  loadingAuth: boolean;
  hasUser: boolean;
  /** Password-provider account with an unverified email */
  needsEmailVerification: boolean;
  /**
   * Brand templates query has data in the cache — even if the latest
   * background refetch failed. Cached data keeps the app mounted so a
   * transient refetch error cannot unmount a healthy session.
   */
  hasBrandsData: boolean;
  /** Brand templates query's latest fetch failed after retries (isError) */
  brandsError: boolean;
}): RootRouteState {
  if (args.loadingAuth) return "loading";
  // Unauthenticated: render normally; the login redirect effect takes over.
  if (!args.hasUser) return "ready";
  if (args.needsEmailVerification) return "verify_email";
  if (args.hasBrandsData) return "ready";
  if (args.brandsError) return "error";
  // No data, no error: fetching, or disabled while auth is pending.
  return "loading";
}
